import { apiSlice } from '../../../store/api/apiSlice';
import type {
  AppointmentBookingStatus,
  AppointmentHistoryPage,
  AppointmentLifecycleStatus,
  AppointmentOperationStatus,
  BrowserAppointment,
  BrowserAppointmentPage,
} from '../types';

interface AppointmentPageRequest {
  limit?: number;
  cursor?: string | null;
  booking_status?: AppointmentBookingStatus;
  lifecycle_status?: AppointmentLifecycleStatus;
  range_start?: string;
  range_end?: string;
  participant_role?: 'coach';
}

export const appointmentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAppointments: builder.query<BrowserAppointmentPage, AppointmentPageRequest | undefined>({
      query: (request) => ({
        url: '/appointments',
        params: cleanParams(request),
      }),
      providesTags: ['Appointments'],
    }),
    getAppointment: builder.query<BrowserAppointment, string>({
      query: (appointmentId) => `/appointments/${encodeURIComponent(appointmentId)}`,
      providesTags: (_result, _error, appointmentId) => [
        { type: 'Appointments', id: appointmentId },
      ],
    }),
    getAppointmentHistory: builder.query<AppointmentHistoryPage, string>({
      query: (appointmentId) => `/appointments/${encodeURIComponent(appointmentId)}/history`,
      providesTags: (_result, _error, appointmentId) => [
        { type: 'Appointments', id: `${appointmentId}:history` },
      ],
    }),
    getAppointmentOperation: builder.query<AppointmentOperationStatus, string>({
      query: (operationId) => `/appointment-operations/${encodeURIComponent(operationId)}`,
      providesTags: (_result, _error, operationId) => [
        { type: 'Appointments', id: `operation:${operationId}` },
      ],
    }),
  }),
});

function cleanParams(params: AppointmentPageRequest | undefined) {
  return Object.fromEntries(
    Object.entries(params ?? {}).filter(([, value]) => value !== undefined && value !== null)
  );
}

export const {
  useGetAppointmentsQuery,
  useLazyGetAppointmentsQuery,
  useGetAppointmentQuery,
  useGetAppointmentHistoryQuery,
  useGetAppointmentOperationQuery,
} = appointmentApi;
